module.exports = __webpack_public_path__ + "static/media/SourceHanSerifTC-SemiBold.180bd297.otf";